import Layout from '@/layout';

export default [
  {
    path: '/studio',
    name: 'Studio',
    redirect: '/studio/introduceVipMember',
    component: Layout,
    meta: {
      title: '工作室',
      icon: 'icon-studio',
      activePath: 'introduceVipMember',
    },
    children: [
      {
        path: 'introduceVipMember',
        name: 'StudioIntroduceVipMember',
        component: () => import('@/views/studio/introduceVipMember.vue'),
        meta: {
          title: '工作室概况',
          activePath: 'introduceVipMember',
        },
      },
    ],
  },
];
